import { ReactNode, createContext, useState } from 'react'

import { RoomConfigurationType } from '@/features/room-config'
import { CartRoom } from '@/stores/cart-store/slices/types'

type RoomContextValue = {
	roomNumber: number
	roomConfig: RoomConfigurationType
	selectedRoom?: CartRoom
	isEditMode: boolean
	showTouristTax?: boolean
	setIsEditMode: (value: boolean) => void
}

type RoomContextProviderProps = Omit<RoomContextValue, 'isEditMode' | 'setIsEditMode'> & {
	children: ReactNode
}

export const RoomContext = createContext<RoomContextValue | undefined>(undefined)

export const RoomContextProvider = ({ children, ...rest }: RoomContextProviderProps) => {
	const [isEditMode, setIsEditMode] = useState(false)

	return (
		<RoomContext.Provider value={{ ...rest, isEditMode, setIsEditMode }}>
			{children}
		</RoomContext.Provider>
	)
}
